import { assertCondition } from '../../../utils/types';
import useOptionalDefaultSchemaId from './useOptionalDefaultSchemaId';
import { isNil } from 'lodash';

const useDefaultBuilderSchemaId = () => {
  const schemaId = useOptionalDefaultSchemaId();
  assertCondition(
    !isNil(schemaId),
    'This hook must be called inside SchemaRequiredRoute',
  );
  return schemaId;
};

export default useDefaultBuilderSchemaId;
